import useAppQuery from 'hooks/useAppQuery';
import API from 'services/API';
import useAppUser from 'hooks/useAppUser';
import { GetIntegrationSettingsResponseTO } from 'models/Integrations';

const useFetchAgencyIntegrationSettings = () => {
  const { agencyUid, isEmployee } = useAppUser();

  const {
    data: integrationSettings,
    isFetching,
    refetch,
  } = useAppQuery(
    ['agencyIntegrationSettings', agencyUid],
    async () => {
      const response = await API.get<GetIntegrationSettingsResponseTO>(
        `v3/integrations-settings?agencyUid=${agencyUid}`,
      );
      return response.data.integrationSettings;
    },
    { enabled: isEmployee && !!agencyUid },
  );

  return { integrationSettings, isFetching, refetch };
};

export default useFetchAgencyIntegrationSettings;
